/* eslint-disable */
import * as Ably from 'ably'
import axios from 'axios'

/**
 * The portal's single Ably connection.
 *
 * The Ably API key used to be compiled into this bundle. It no longer is: the browser
 * asks GET /realtime/ably/session for a short-lived, subscribe-only token request
 * scoped to exactly one channel, and the backend decides that scope from the logged-in
 * user. A tampered frontend cannot widen its own access.
 *
 * Base URL is read from the environment rather than the Vuex store on purpose: store.js
 * imports this module, and src/api/*.js read store.getters.mainAppURL at module scope,
 * so importing the store back here would be a circular import.
 */
function baseURL () {
    const url = process.env.VUE_APP_BASE_URL
    return (url && url.endsWith('/')) ? url : url + '/'
}

let client = null

/**
 * Authorization rides on axios.defaults.headers.common, set in main.js on boot and
 * refreshed by the login and refresh-token actions in store.js.
 */
export function fetchRealtimeSession () {
    return axios.get(baseURL() + 'realtime/ably/session').then(resp => resp.data)
}

export function getAblyClient () {
    if (client) return client

    client = new Ably.Realtime({
        // Called on connect AND on every token renewal. The token lives one hour, the
        // portal session eight, so this must re-fetch every time: caching it drops the
        // connection with error 40142 about an hour in. Each token request is single-use.
        authCallback: (tokenParams, callback) => {
            fetchRealtimeSession()
                .then(session => callback(null, session.token_request))
                .catch(error => callback(error, null))
        },
        // Don't hammer the endpoint on a flaky network.
        disconnectedRetryTimeout: 5000,
        suspendedRetryTimeout: 30000
    })

    return client
}

export function closeAblyClient () {
    if (client) {
        client.close()
        client = null
    }
}
